export default __webpack_public_path__ + "static/media/Magnapool_Minerals.d75fcecf.webp";